var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnadir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5149 5.1011H10.8901V4.48494C10.8901 4.2208 10.6729 4.00659 10.4052 4.00659C10.1375 4.00659 9.92026 4.2208 9.92026 4.48494V5.1011H9.29549C9.02752 5.1011 8.81055 5.31531 8.81055 5.57945C8.81055 5.8436 9.02777 6.0578 9.29549 6.0578H9.92026V6.67397C9.92026 6.93811 10.1375 7.15232 10.4052 7.15232C10.6729 7.15232 10.8901 6.93811 10.8901 6.67397V6.0578H11.5149C11.7829 6.0578 11.9999 5.8436 11.9999 5.57945C11.9999 5.31531 11.7826 5.1011 11.5149 5.1011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60946 11.5424C6.86204 12.0257 4.35053 12.2676 1.79589 11.5424C0.80088 11.26 0 10.6318 0 9.73032C0 8.82056 0.829048 8.24709 1.82127 7.91529C3.86914 7.22997 6.15048 7.14733 8.58408 7.91529C9.58214 8.23011 10.4053 8.82056 10.4053 9.73032C10.4053 10.6318 9.607 11.2665 8.60946 11.5424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20286 6.59004C7.04779 6.59004 8.54341 5.11481 8.54341 3.29502C8.54341 1.47523 7.04779 0 5.20286 0C3.35792 0 1.8623 1.47523 1.8623 3.29502C1.8623 5.11481 3.35792 6.59004 5.20286 6.59004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnadir);
export default __webpack_public_path__ + "static/media/anadir.4e6fc31b8cd161eae16a72aa3ef3f38d.svg";
export { ForwardRef as ReactComponent };